import { render } from "./inventorySetMenu.vue?vue&type=template&id=8c17b7a8&scoped=true"
import script from "./inventorySetMenu.vue?vue&type=script&lang=js"
export * from "./inventorySetMenu.vue?vue&type=script&lang=js"

import "./inventorySetMenu.vue?vue&type=style&index=0&id=8c17b7a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c17b7a8"

export default script